import { render } from "./AlertsApp.vue?vue&type=template&id=7c38d61b"
import script from "./AlertsApp.vue?vue&type=script&lang=js"
export * from "./AlertsApp.vue?vue&type=script&lang=js"

import "./AlertsApp.vue?vue&type=style&index=0&id=7c38d61b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__